import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { API_BASE } from "../../config/api";

const url = `${API_BASE}/user/signup`;

const Register = () => {
  const [data, setData] = useState({
    username: "",
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = ({ currentTarget: input }) => {
    setData({ ...data, [input.name]: input.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(url, data);
      navigate("/login");
    } catch (err) {
      if (
        err.response &&
        err.response.status >= 400 &&
        err.response.status <= 500
      ) {
        setError(err.response.data.message);
      }
    }
  };

  return (
    <div className="mv-page flex min-h-[calc(100vh-3.5rem)] flex-col items-center justify-center px-4 py-16">
      <div className="mv-card w-full max-w-md p-8 md:p-10">
        <h1 className="mv-heading text-center text-2xl md:text-3xl">
          Create account
        </h1>

        <form className="mt-8 space-y-5" onSubmit={handleSubmit}>
          <div>
            <label className="mv-label" htmlFor="signup-username">
              Username
            </label>
            <input
              id="signup-username"
              className="mv-input"
              type="text"
              name="username"
              autoComplete="username"
              placeholder="Pick a username"
              onChange={handleChange}
            />
          </div>
          <div>
            <label className="mv-label" htmlFor="signup-email">
              Email
            </label>
            <input
              id="signup-email"
              className="mv-input"
              type="email"
              name="email"
              autoComplete="email"
              placeholder="you@example.com"
              onChange={handleChange}
            />
          </div>
          <div>
            <label className="mv-label" htmlFor="signup-password">
              Password
            </label>
            <input
              id="signup-password"
              className="mv-input"
              type="password"
              name="password"
              autoComplete="new-password"
              placeholder="Minimum 8 characters"
              onChange={handleChange}
            />
          </div>
          {error && <p className="text-sm text-rose-400">{error}</p>}
          <button type="submit" className="mv-btn-primary w-full py-3">
            Register
          </button>
        </form>

        <p className="mt-8 text-center text-sm text-slate-500">
          Already have access?{" "}
          <Link
            to="/login"
            className="font-semibold text-cinema-accent hover:text-cinema-accent-hover"
          >
            Log in
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
